import React from 'react';
import { FaFacebook, FaTelegram, FaTwitter, FaInstagram } from 'react-icons/fa';
import { CgMail } from 'react-icons/cg'

export default function Footer() {
  return (
    <footer>
        <div className="media">
            <a href="." title="Facebook"><FaFacebook /></a>
            <a href="." title="Instagram"><FaInstagram /></a>
            <a href="." title="Twitter"><FaTwitter /></a>
            <a href="." title="Gmail"><CgMail /></a>
            <a href="https://t.me/abcde120000" target="_blank" rel='noreferrer' title="Telegram"
                ><FaTelegram /></a>
        </div>
        <p className="copy">&copy;2021, All rights reserved.</p>
        <p className="credit">
            Made with ❤️ by <a href="mailto:abdimad786@gmail.com" rel='noreferrer' target="_blank">Imad</a>.
        </p>
	</footer>
  )
}
